import type { Theme } from '@mui/material';

export const styles = {
  tagCloud: (width: number, height: number) => ({
    width,
    height,
    position: 'relative',
    alignItems: 'center',
    p: 0,
    m: 0,
  }),

  textRoot: (x: number, y: number) => ({
    top: '50%',
    left: '50%',
    position: 'absolute',
    height: '0', // this element is only a reference point for the placement of the texts
    width: '0', // this element is only a reference point for the placement of the texts
    fontFamily: 'Inter',
    textAnchor: 'middle',
    transform: `translate(${x}px,${y}px)`,
    textWrap: 'nowrap',
    overflow: 'visible',
  }),

  text:
    (size: number, font: string, weight: string | number, colorIndex: number) =>
    (theme: Theme) => ({
      cursor: 'pointer',
      marginTop: `${0.125 * size}px`, // places the reference point near the text
      font: font,
      height: `${size}px`,
      lineHeight: `${size}px`,
      transform: `translate(-50%, -100%)`,
      fontWeight: weight,
      fontSize: size,
      position: 'absolute',
      textAlign: 'center',
      alignContent: 'center',
      color: [
        theme.colors.secondary[400],
        theme.colors.primary[400],
        theme.colors.primary[600],
        theme.colors.primary[800],
        theme.colors.primary[900],
      ][colorIndex],
    }),

  error: (theme: Theme) => ({
    color: theme.colors.primary[500],
    backgroundColor: theme.colors.primary[50],
    alignSelf: 'center',
  }),
};
